import RMRatingUseCase from "@domains/salesFeatures/Profile/useCases/RMRatingUseCase";
import RatingsUseCase from "@domains/salesFeatures/Profile/useCases/RatingsUseCase";
import ProfileUseCase from "@domains/salesFeatures/Profile/useCases/ProfileDetailsUseCase";
import ClientRatingSummaryUseCase from "@domains/salesFeatures/Profile/useCases/ClientRatingSummaryUseCase";
import ProfileImageUseCase from "@domains/salesFeatures/Profile/useCases/ProfileImageUseCase";
import CreaticalActivityUseCase from "@domains/salesFeatures/Profile/useCases/CreaticalActivityUseCase";
import PostProfileImageUseCase from "@domains/salesFeatures/Profile/useCases/ProfileImagePostUseCase";
import SocialMediaUseCase from "@domains/salesFeatures/Profile/useCases/SocialMediaUseCase";
import ONDeskUseCase from "@domains/salesFeatures/Profile/useCases/ONDeskUseCase";
import UpdateOnDeskUseCase from "@domains/salesFeatures/Profile/useCases/UpdateONDeskUseCase";
import ClientRatingSummaryEntityUseCase from "@domains/salesFeatures/Profile/useCases/ClientRatingSummaryEntityUseCase";
import ClientRatingSummaryDetailsUseCase from "@domains/salesFeatures/Profile/useCases/ClientRatingSummaryDetailsUseCase";
import SocialMediaDetailsUseCase from "@domains/salesFeatures/Profile/useCases/SocialMediaDetailsUseCase";
import GetUPCUseCase from "@domains/salesFeatures/Profile/useCases/GetUPCUseCase";
import GetUserMenuUsecase from "@domains/salesFeatures/Profile/useCases/GetUserMenuUsecase";
import GetPreferenceUseCase from "@domains/salesFeatures/Profile/useCases/GetPreferenceUseCase";
import SavePreferenceUseCase from "@domains/salesFeatures/Profile/useCases/SavePreferenceUseCase";
import ValidateFeedbackUseCase from "@domains/salesFeatures/Profile/useCases/ValidateFeedbackUseCase";
import SaveDashboardFeedbackUseCase from "@domains/salesFeatures/Profile/useCases/SaveDashboardFeedbackUseCase";
import DocumentUploadUseCase from "@domains/salesFeatures/Profile/useCases/DocumentUploadUseCase";
import SupersetMenuListUseCase from "@domains/salesFeatures/Profile/useCases/SupersetMenuListUseCase";
import MarkAbsenteeUseCase from "@domains/salesFeatures/Profile/useCases/MarkAbsenteeUseCase";
import AbsenteeSampleFileUseCase from "@domains/salesFeatures/Profile/useCases/AbsenteeSampleFileUseCase";
import AccountOpeningUrlsUseCase from "@domains/salesFeatures/Profile/useCases/AccountOpeningUrlsUseCase";
import DownloadAbsenteeFileUseCase from "@domains/salesFeatures/Profile/useCases/DownloadAbsenteeFileUseCase";
import GetAbsenteeDataUseCase from "@domains/salesFeatures/Profile/useCases/GetAbsenteeDataUseCase";
export default (function (repo) {
    return {
        profile: {
            profileDetailsUseCase: new ProfileUseCase(repo.profile),
            rmDetailsratingUseCase: new RMRatingUseCase(repo.profile),
            profileImageUseCase: new ProfileImageUseCase(repo.profile),
            ratingsUseCase: new RatingsUseCase(repo.profile),
            clientRatingSummary: new ClientRatingSummaryUseCase(repo.profile),
            creaticalActivityUseCase: new CreaticalActivityUseCase(repo.profile),
            postProfileImageUseCase: new PostProfileImageUseCase(repo.profile),
            socialMediaUseCase: new SocialMediaUseCase(repo.profile),
            onDeskUseCase: new ONDeskUseCase(repo.profile),
            updateOnDeskUseCase: new UpdateOnDeskUseCase(repo.profile),
            clientRatingSummaryEntity: new ClientRatingSummaryEntityUseCase(repo.profile),
            clientRatingSummaryDetailsEntity: new ClientRatingSummaryDetailsUseCase(repo.profile),
            socialMediaDetailsUseCase: new SocialMediaDetailsUseCase(repo.profile),
            getUPCUseCase: new GetUPCUseCase(repo.profile),
            getUserMenu: new GetUserMenuUsecase(repo.profile),
            getPreference: new GetPreferenceUseCase(repo.profile),
            savePreference: new SavePreferenceUseCase(repo.profile),
            getValidateFeedbackData: new ValidateFeedbackUseCase(repo.profile),
            saveDashboardFeedback: new SaveDashboardFeedbackUseCase(repo.profile),
            documentUpload: new DocumentUploadUseCase(repo.profile),
            supersetMenuList: new SupersetMenuListUseCase(repo.profile),
            markAbsentee: new MarkAbsenteeUseCase(repo.profile),
            getAbsenteeSampleFile: new AbsenteeSampleFileUseCase(repo.profile),
            getAccountOpeningUrls: new AccountOpeningUrlsUseCase(repo.profile),
            downloadAbsenteeFile: new DownloadAbsenteeFileUseCase(repo.profile),
            getAbsenteeData: new GetAbsenteeDataUseCase(repo.profile),
        },
    };
});
